import { Injectable } from '@angular/core';

import { Observable, Subject } from 'rxjs';

import {
    LesseeFactory
} from './Factories';
import {
    LesseeService, LesseeCustomService
} from '../_services';
import { Lessee as T, Serialized, Product } from './Interfaces';
import { Lessee as C } from './Classes';

@Injectable()
export class Lessee {
    collection: C[] = [];
    item: C;
    changed$: Subject<C> = new Subject<C>();
    constructor(
        private factory: LesseeFactory,
        private main: LesseeService,
        private custom: LesseeCustomService
    ) {
        if (!this.item) this.make({});
    }
    empty() {
        return !this.item.id;
    }
    get instance() {
        return this.item;
    }
    set instance(value) {
        this.item = value;
        this.changed$.next(this.item);
    }
    isInstance(test) {
        return test instanceof C;
    }
    make(json) {
        this.item = this.factory.createInstance(json);
        this.changed$.next(this.item);
        return this.item;
    }
    get(id: number, params?: string): Observable<C> {
        return this.main.get(id, params).map((response: Serialized) => {
            this.item = this.factory.createInstance(response.data);
            this.changed$.next(this.item);
            return this.item;
        });
    }
    getAll(params?: string): Observable<C[]> {
        return this.main.getAll(params).map((response: Serialized) => {
            this.collection = this.factory.createInstances(response.data);
            return this.collection;
        });
    }
    put(id: number, body: T) {
        return this.main.put(id, body).map((response: Serialized) => {
            return response;
        });
    }
    post(body: T) {
        return this.main.post(body).map((response: Serialized) => {
            return response.data;
        });
    }
    delete(id: number) {
        return this.main.delete(id).map((response: Serialized) => {
            return response;
        });
    }
    search(searchString: string) {
        return this.custom.search(searchString).map((response: Serialized) => {
            return response;
        });
    }
}

export const LesseeProviders = [
    LesseeService,
    LesseeCustomService,
    LesseeFactory,
    // This class dependencies
    {
        provide: Lessee,
        useClass: Lessee,
        deps: [
            LesseeFactory, LesseeService, LesseeCustomService
        ]
    }
];



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/_models/lessee.ts